import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Image,
  Portal,
  Progress,
  SimpleGrid,
  Spacer,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorMode,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
// assets
import peopleImage from "assets/img/people-image.png";
import logoChakra from "assets/svg/logo-white.svg";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import BarChart from "components/Charts/BarChart";
import LineChart from "components/Charts/LineChart";
import IconBox from "components/Icons/IconBox";
// Custom icons
import {
  CartIcon,
  DocumentIcon,
  GlobeIcon,
  RocketIcon,
  StatsIcon,
  WalletIcon,
  PersonIcon
} from "components/Icons/Icons.js";
import DashboardTableRow from "components/Tables/DashboardTableRow";
import TimelineRow from "components/Tables/TimelineRow";
// react icons
import { BsArrowRight } from "react-icons/bs";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import { dashboardTableData, timelineData } from "variables/general";
import CreateEstimate from "../../views/Custom/CreateEstimate";
import OrdersTable from "../../views/Custom/OrdersTable";
import useGetMe from "../../hooks/useGetMe";
import useLogout from "../../hooks/useLogout";
import DashboardTotal from "views/Custom/DashboardTotal";
import MechanicSummary from "views/Custom/MechanicSummary";

export default function Dashboard() {

  const { setGettingMe, unauthorized } = useGetMe();
  const { setLoggingOut } = useLogout();

  useEffect(() => {
    setGettingMe(true);
  }, []);

  useEffect(() => {
    if (unauthorized) {
      setLoggingOut(true);
    }
  }, [unauthorized]);

  const value = "$100.000";
  // Chakra Color Mode
  const { colorMode, toggleColorMode } = useColorMode();
  const iconTeal = useColorModeValue("teal.300", "teal.300");
  const iconBoxInside = useColorModeValue("white", "white");
  const textColor = useColorModeValue("gray.700", "white");


  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing="24px">
        <DashboardTotal type={"Day"}/>
        <DashboardTotal type={"Week"}/>
        <DashboardTotal type={"Month"}/>
        <DashboardTotal type={"Year"}/>
      </SimpleGrid>

      <Grid
        templateColumns={{ sm: "1fr 1fr", md: "1fr 1fr", lg: "2.3fr 0.5fr" }}
        templateRows={{ md: "1fr auto"}}
        my="12px"
        gap="24px"
      >
        <Card p="1.2rem">
          <CardBody 
            w="100%"
            h={{ sm: "auto", lg: "auto" }}
            position="relative"
            borderRadius="15px"
            style={{ overflow: "auto"}}
          >
            <OrdersTable /> 
          </CardBody>
        </Card>


        <Card p="1.2rem">
          <CardBody 
            w="100%"
            h={{ sm: "auto", lg: "auto" }}
            position="relative"
            borderRadius="15px">
            
            <Flex direction="column">
              <Text
                fontSize="lg"
                color={textColor}
                fontWeight="bold"
                pb=".5rem"
              >
                Mechanics overview
              </Text>
              <Text fontSize="sm" color="gray.400" fontWeight="normal">
                <Text fontWeight="bold" as="span" color="teal.300">
                  Ongoing 
                </Text>{" "}
                Orders.
              </Text>
              <MechanicSummary /> 
            </Flex>
          </CardBody>
        </Card>

      </Grid>


      


    </Flex>
  );
}
